import styled from "styled-components";

import { clamp } from "@styles/utils/conversion.style";
import { colors } from "@styles/vars/colors.style";
import { mq } from "@styles/vars/media-queries.style";

export const OurMissionGridMain = styled.section`
  position: relative;
  width: 100%;
  overflow: hidden;
  background: ${colors.white};
  color: ${colors.charcoal};

  ${mq.tabletPMax} {
    overflow: visible;
  }
`;

export const OurMissionGridWrapper = styled.div`
  position: relative;
  width: 100%;
  padding: clamp(4rem, 8vw, 8rem) 0;
`;

export const OurMissionGridHeader = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  width: 100%;
  min-height: clamp(12rem, 22vw, 18rem);
  margin-bottom: clamp(2.5rem, 5vw, 4.5rem);

  ${mq.tabletPMax} {
    display: block;
    min-height: 0;
    margin-bottom: 2.5rem;
  }
`;

export const OurMissionGridCenterLine = styled.div`
  display: none;

  ${mq.tabletL} {
    position: absolute;
    top: calc(clamp(4rem, 8vw, 8rem) * -1);
    bottom: 0;
    left: 50%;
    display: block;
    width: 1px;
    background: ${colors.charcoal};
    opacity: 0.75;
    transform: translateX(-50%);
    transform-origin: top center;
    pointer-events: none;
    will-change: transform;
  }
`;

export const OurMissionGridTitle = styled.div`
  grid-column: 2 / 3;
  width: 100%;
  padding-left: 80px;
  padding-bottom: 20px;
  align-self: center;
  justify-self: start;

  
  
  p{
    ${clamp("font-size", 26, 52)};
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  strong {
    font-weight: 900;
  }

  ${mq.tabletPMax} {
    width: 100%;
    max-width: none;
    padding-left: 0;
  }
`;

export const OurMissionGridItems = styled.div`
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: clamp(1rem, 3vw, 3rem);
  width: 100%;
  margin-bottom: clamp(3rem, 6vw, 6rem);

  ${mq.tabletPMax} {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    margin-bottom: 3rem;
  }
`;

export const OurMissionGridItem = styled.article`
  position: relative;
  width: 100%;
  aspect-ratio: 5/4;
  overflow: hidden;
  background: ${colors.pastelGreen};
  isolation: isolate;
  ${mq.tabletL} {
    &:hover .overlay, &:hover .text {
      opacity: 1;
    }
  }
  ${mq.tabletPMax} {
    min-height: 18rem;
  }
`;

export const OurMissionGridItemImage = styled.img`
  position: absolute;
  inset: 0;
  z-index: -2;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const OurMissionGridItemOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: -1;
  transition: all 0.25s ease;
  ${mq.tabletL} {
      opacity: 0;
  }
  background: linear-gradient(
    180deg,
    rgba(215, 255, 218, 0) 0%,
    rgba(215, 255, 218, 0.22) 10%,
    ${colors.pastelGreen} 100%
  );
`;

export const OurMissionGridItemText = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  padding: clamp(1rem, 2vw, 2.5rem);

  transition: all 0.25s ease;
  ${mq.tabletL} {
      opacity: 0;
      p {
        min-height: 140px;
      }
  }

  p {
    ${clamp("font-size", 22, 32)};
  }

  strong {
    font-weight: 700;
  }
`;

export const OurMissionGridFooter = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  width: 100%;

  ${mq.tabletPMax} {
    display: block;
  }
`;

export const OurMissionGridSubTitle = styled.div`
  grid-column: 1 / 2;
  width: 100%;
  justify-self: start;


  p{
    ${clamp("font-size", 26, 52)};
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  ${mq.tabletPMax} {
    width: 100%;
    max-width: none;
    padding-right: 0;
  }
`;